var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubInput = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 25,
  viewBox: "0 0 9 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 0V22C1 23.1046 1.89543 24 3 24H9",
  stroke: "#DCDFE0"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubInput);
export default ForwardRef;